import { showErrorToast } from "app/actions/toast_actions";
import { translate } from "app/filters/i18nFilter";
import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";
import type { CRMListObjectsType, CrmFeedLevel } from "../../../types";
import { managementActions } from "../../action-creators";
import { setSfCrmFeedLevel, setSfCrmListObjectsType } from "../../actions/salesforceActions";
import { selectSalesforceFeedLevel, selectSfListObjectsType } from "../../selectors/salesforceSelectors";

export const putSfAccountsToggleThunk =
    (status: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.putAccountsToggleAsync.request());
            const response = await deps.si.api.management.putSfAccountsToggle(status);

            dispatch(managementActions.salesforce.putAccountsToggleAsync.success(response));
        } catch (error) {
            dispatch(managementActions.salesforce.putAccountsToggleAsync.failure(error));
        }
    };

export const putSfContactsToggleThunk =
    (value: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.putContactsToggleAsync.request());
            const response = await deps.si.api.management.putSfContactsToggle(value);

            dispatch(managementActions.salesforce.putContactsToggleAsync.success(response));
        } catch (error) {
            dispatch(managementActions.salesforce.putContactsToggleAsync.failure(error));
        }
    };

export const putSfLeadsToggleThunk =
    (value: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.putLeadsToggleAsync.request());
            const response = await deps.si.api.management.putSfLeadsToggle(value);

            dispatch(managementActions.salesforce.putLeadsToggleAsync.success(response));
        } catch (error) {
            dispatch(managementActions.salesforce.putLeadsToggleAsync.failure(error));
        }
    };

export const putSfCompanyAsLeadsToggleThunk =
    (value: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.putCompanyAsLeadsToggleAsync.request());
            const response = await deps.si.api.management.putSfCompanyAsLeadsToggle(value);

            dispatch(managementActions.salesforce.putCompanyAsLeadsToggleAsync.success(response));
        } catch (error) {
            dispatch(managementActions.salesforce.putCompanyAsLeadsToggleAsync.failure(error));
        }
    };

export const setIsSfCrmLabelEnabledThunk =
    (payload: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.setIsSfCrmLabelEnabled(payload));
            await deps.si.api.management.setIsSfCrmLabelEnabled(payload);
        } catch (error) {
            dispatch(managementActions.salesforce.setIsSfCrmLabelEnabled(!payload));
            dispatch(showErrorToast(translate("si.crm-integration.update-is-crm-label-enabled.error")));
        }
    };

export const setIsSfFeedEnabledThunk =
    (payload: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.setIsSfFeedEnabled(payload));
            await deps.si.api.management.setIsSfFeedEnabled(payload);
        } catch (error) {
            dispatch(managementActions.salesforce.setIsSfFeedEnabled(!payload));
            dispatch(showErrorToast(translate("si.crm-integration.update-is-crm-feed-enabled.error")));
        }
    };

export const setIsSfCrmListEnabledThunk =
    (payload: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.setIsSfCrmListEnabled(payload));
            await deps.si.api.management.setIsSfCrmListEnabled(payload);
        } catch (error) {
            dispatch(managementActions.salesforce.setIsSfCrmListEnabled(!payload));
            dispatch(showErrorToast(translate("si.crm-integration.update-is-crm-list-enabled.error")));
        }
    };

export const setSfCrmListObjectsTypeThunk =
    (objectsType: CRMListObjectsType) =>
    async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, deps: ThunkDependencies) => {
        const prevObjectsType = selectSfListObjectsType(getState());
        try {
            dispatch(setSfCrmListObjectsType(objectsType));
            await deps.si.api.management.setSfCrmListObjectsType(objectsType);
        } catch (error) {
            dispatch(setSfCrmListObjectsType(prevObjectsType));
            dispatch(showErrorToast(translate("si.crm-integration.update-crm-list-objects-type.error")));
        }
    };

export const setSfCrmFeedLevelThunk =
    (feedLevel: CrmFeedLevel) =>
    async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, deps: ThunkDependencies) => {
        const prevFeedLevel = selectSalesforceFeedLevel(getState());
        try {
            dispatch(setSfCrmFeedLevel(feedLevel));
            await deps.si.api.management.setSfCrmFeedLevel(feedLevel);
        } catch (error) {
            dispatch(setSfCrmFeedLevel(prevFeedLevel));
            dispatch(showErrorToast(translate("si.crm-integration.update-is-crm-feed-enabled.error")));
        }
    };
